export class TypeOfPersonnel {
  id: number;
  typeOfPersonnelCode: string;
  typeOfPersonnelName: string;
  formType: number;
  displayOrder: number;
}
